import {
  ChainIdLegacy,
  ProviderKey,
  SupportedChainId,
  SupportedChainValue,
  providers,
} from "@silo/types";

export const serverRpc: Record<ProviderKey, SupportedChainValue<string>> = {
  infura: {
    [ChainIdLegacy.MAINNET]: `https://mainnet.infura.io/v3/${process.env.INFURA_KEY}`,
    [ChainIdLegacy.ARBITRUM]: `https://arbitrum-mainnet.infura.io/v3/${process.env.INFURA_KEY}`,
    [ChainIdLegacy.OPTIMISM]: `https://optimism-mainnet.infura.io/v3/${process.env.INFURA_KEY}`,
    [ChainIdLegacy.BASE]: `https://base-mainnet.infura.io/v3/${process.env.INFURA_KEY}`,
    [ChainIdLegacy.ANVIL]: "https://anvil.silo.finance/",
    [ChainIdLegacy.LOCAL]: "http://localhost:8545",
  },
  alchemy: {
    [ChainIdLegacy.MAINNET]: `https://eth-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_KEY}`,
    [ChainIdLegacy.ARBITRUM]: `https://arb-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_KEY}`,
    [ChainIdLegacy.OPTIMISM]: `https://opt-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_KEY}`,
    [ChainIdLegacy.BASE]: `https://base-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_KEY}`,
    [ChainIdLegacy.ANVIL]: "https://anvil.silo.finance/",
    [ChainIdLegacy.LOCAL]: "http://localhost:8545",
  },
  drpc: {
    [ChainIdLegacy.MAINNET]: `https://lb.drpc.live/ogrpc?network=ethereum&dkey=${process.env.DRPC_KEY}`,
    [ChainIdLegacy.ARBITRUM]: `https://lb.drpc.live/ogrpc?network=arbitrum&dkey=${process.env.DRPC_KEY}`,
    [ChainIdLegacy.OPTIMISM]: `https://lb.drpc.live/ogrpc?network=optimism&dkey=${process.env.DRPC_KEY}`,
    [ChainIdLegacy.BASE]: `https://lb.drpc.live/ogrpc?network=base&dkey=${process.env.DRPC_KEY}`,
    [ChainIdLegacy.ANVIL]: "https://anvil.silo.finance/",
    [ChainIdLegacy.LOCAL]: "http://localhost:8545",
  },
};

export function getServerRpcUrls(chainId: SupportedChainId): string[] {
  const urls = providers.map((provider) => serverRpc[provider][chainId]);

  return urls;
}

